<template>
  <div>
    <div>
       <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important; padding-left: 0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <!-- <b-navbar-nav>
            <b-button @click="previousSalesView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true"
                >skip_previous</md-icon
              >Back
            </b-button>
          </b-navbar-nav> -->
          <b-navbar-brand center
            >Supplementary Invoice FF Import</b-navbar-brand
          >
        </b-navbar>

        <b-card class="formCard">
          <b-card-text>
            <div>
              <!-- *******************************  Start  WareHouse  Warehouse Stuffing At ICD *****************************-->
              <div
                class="mt-2"
                v-if="containerTypeDetailFactoryList.length > 0"
              >
                <h5>
                  <b-badge>Container Details</b-badge>
                </h5>
                <div>
                  <b-button
                    v-if="
                      ContainerTypeSizefactory.ccExecutionContainerId != '' &&
                      showMoreSB == false
                    "
                    size="sm"
                    variant="outline-dark"
                    @click="showMoreSBDet"
                    >{{ showMoreSB == true ? "Show" : "Hide " }} Container
                    Details</b-button
                  >
                </div>

                <!-- /.box-header -->

                <b-card
                  class="mt-3"
                  v-if="
                    (getContainerList.length > 0 ||
                      ContainerTypeSizefactory.ccExecutionContainerId != '') &&
                    showMoreSB == false
                  "
                  style="background: whiteSmoke"
                >
                  <div
                    class="gutr"
                    v-if="
                      getContainerList.length > 0 ||
                      ContainerTypeSizefactory.ccExecutionContainerId != ''
                    "
                  >
                    <div v-if="showMoreSB == false">
                      <!-- <md-layout md-gutter>
                          <md-layout md-flex="5"></md-layout>
                          <md-layout md-flex="95">
                            <label>
                              <b>
                                <u>
                                  Container Details
                                  <span
                                    class="error"
                                    v-if="containerTypeDetailFactory.length==0"
                                  >{{errorAtleastContainer}}</span>
                                </u>
                              </b>
                            </label>
                          </md-layout>
                        </md-layout> -->

                      <md-layout md-gutter class="labelMargtop">
                        <md-layout md-flex="50">
                          <label
                            v-if="
                              ContainerTypeSizefactory.ccExecutionContainerId ==
                              ''
                            "
                            >Container Type/Size</label
                          >
                          <model-list-select
                            v-if="
                              ContainerTypeSizefactory.ccExecutionContainerId ==
                              ''
                            "
                            option-value="containerTypeId"
                            option-text="containerType"
                            :list="ContainerTypeList"
                            placeholder="Select  Type/Size"
                            v-model="ContainerTypeSizefactory.containerTypeId"
                          ></model-list-select>
                          <md-layout md-flex="100" v-else>
                            <label for="containerType"
                              >Container Type/Size</label
                            >
                            <b-form-input
                              :formatter="capitalizeAll"
                              v-model="ContainerTypeSizefactory.containerType"
                              disabled
                            ></b-form-input>
                          </md-layout>
                          <span
                            class="error"
                            v-if="!ContainerTypeSizefactory.containerTypeId"
                            >{{ errorContainer.containerTypeId }}</span
                          >
                        </md-layout>

                        <md-layout md-flex="5"></md-layout>
                        <md-layout md-flex="45">
                          <md-layout md-flex="100">
                            <label>Container No.(eg. AAAA1234567)</label>
                            <b-form-input
                              :formatter="capitalizeAll"
                              name="containerNo"
                              v-model="ContainerTypeSizefactory.containerNo"
                              @keyup="containerNoRegexfun"
                            ></b-form-input>
                          </md-layout>
                          <span
                            class="error"
                            v-if="!ContainerTypeSizefactory.containerNo"
                            >{{ errorContainer.containerNo }}</span
                          >
                          <span
                            class="error"
                            v-else-if="containerNoRegexError != ''"
                            >{{ containerNoRegexError }}</span
                          >
                          <span
                            class="error"
                            v-if="
                              containerNoRegexError == '' &&
                              ContainerTypeSizefactory.containerNo != '' &&
                              ContainerTypeSizefactory.containerNo !=
                                algoConNo &&
                              showAlgo == true
                            "
                            >Note:System Generated Container No. is :
                            {{ algoConNo }}</span
                          >
                        </md-layout>
                      </md-layout>
                      <md-layout md-gutter class="labelMargtop">
                        <md-layout md-flex="55"></md-layout>
                        <md-layout md-flex="10">
                          <md-layout md-flex="100">
                            <label>Net Wgt.</label>
                            <b-form-input
                              :formatter="capitalizeAll"
                              id="netWeight"
                              name="netWeight"
                              type="number"
                              min="0"
                              v-model="ContainerTypeSizefactory.netWeight"
                            ></b-form-input>
                          </md-layout>
                        </md-layout>
                        <md-layout md-flex="5"></md-layout>
                        <md-layout md-flex="10">
                          <md-layout md-flex="100">
                            <label>Gross Wgt</label>
                            <b-form-input
                              :formatter="capitalizeAll"
                              id="grossWeight"
                              name="grossWeight"
                              type="number"
                              min="0"
                              v-model="ContainerTypeSizefactory.grossWeight"
                            ></b-form-input>
                          </md-layout>

                          <span
                            class="error"
                            v-if="!ContainerTypeSizefactory.grossWeight"
                            >{{ errorContainer.grossWeight }}</span
                          >
                        </md-layout>

                        <md-layout md-flex="5"></md-layout>

                        <md-layout md-flex="15">
                          <label for="weightUnit">Unit</label>
                          <model-list-select
                            :list="unitList"
                            option-value="uV"
                            option-text="uT"
                            placeholder="Select Unit"
                            name="weightUnit"
                            id="weightUnit"
                            v-model="ContainerTypeSizefactory.weightUnit"
                          ></model-list-select>
                        </md-layout>
                      </md-layout>

                      <md-layout md-gutter class="labelMargtop">
                        <md-layout md-flex="15">
                          <label>Handover Date</label>
                          <date-picker
                            :format="selectDateFormat"
                            lang="en"
                            :minute-step="1"
                            name="handoverDate"
                            id="handoverDate"
                            v-model="ContainerTypeSizefactory.handoverDate"
                          ></date-picker>
                        </md-layout>

                        <md-layout md-flex="5"></md-layout>

                        <md-layout md-flex="25">
                          <md-layout md-flex="100">
                            <label>Custom Seal No.</label>
                            <b-form-input
                              :formatter="capitalizeAll"
                              id="customSealNo"
                              name="customSealNo"
                              v-model="ContainerTypeSizefactory.customSealNo"
                            ></b-form-input>
                          </md-layout>
                        </md-layout>
                        <md-layout md-flex="5"></md-layout>
                        <md-layout md-flex="25">
                          <md-layout md-flex="100">
                            <label>Line Seal No.</label>
                            <b-form-input
                              :formatter="capitalizeAll"
                              id="LineSealNo"
                              name="LineSealNo"
                              v-model="ContainerTypeSizefactory.LineSealNo"
                            ></b-form-input>
                          </md-layout>
                        </md-layout>
                        <md-layout md-flex="5"></md-layout>
                        <md-layout md-flex="20">
                          <md-layout md-flex="100">
                            <label>Container Tare Wgt</label>
                            <b-form-input
                              :formatter="capitalizeAll"
                              id="tareWeight"
                              name="tareWeight"
                              type="number"
                              min="0"
                              v-model="ContainerTypeSizefactory.tareWeight"
                            ></b-form-input>
                          </md-layout>
                        </md-layout>
                      </md-layout>

                      <md-layout md-gutter class="labelMargtop">
                        <md-layout md-flex="20">
                          <md-layout md-flex="100">
                            <label>Measurement (in CBM)</label>
                            <b-form-input
                              :formatter="capitalizeAll"
                              name="noOfpkgUnit"
                              id="noOfpkgUnit"
                              type="number"
                              min="0"
                              v-model="ContainerTypeSizefactory.measurement"
                            ></b-form-input>
                            <!-- <span
                    class="error"
                    v-if="!ContainerTypeSizefactory.measurement"
                              >{{errorContainer.measurement}}</span>-->
                          </md-layout>
                        </md-layout>

                        <md-layout md-flex="5"></md-layout>
                        <md-layout md-flex="20">
                          <label>Package Details</label>
                          <model-list-select
                            :list="packageNameList"
                            id="clientId"
                            v-model="ContainerTypeSizefactory.packageId"
                            option-value="packageId"
                            option-text="packageName"
                            placeholder="Select  Package Name"
                          ></model-list-select>

                          <span
                            class="error"
                            v-if="!ContainerTypeSizefactory.packageId"
                            >{{ errorContainer.packageId }}</span
                          >
                        </md-layout>
                        <md-layout md-flex="5"></md-layout>
                        <md-layout md-flex="50">
                          <md-layout md-flex="100">
                            <label
                              >No. of Packages ({{
                                ContainerTypeSizefactory.packageName
                              }})</label
                            >
                            <b-form-input
                              :formatter="capitalizeAll"
                              name="noOfpkgUnit"
                              id="noOfpkgUnit"
                              type="number"
                              min="0"
                              :disabled="
                                ContainerTypeSizefactory.packageName == ''
                                  ? true
                                  : false
                              "
                              v-model="ContainerTypeSizefactory.noOfpkgUnit"
                            ></b-form-input>
                            <span
                              class="error"
                              v-if="!ContainerTypeSizefactory.noOfpkgUnit"
                              >{{ errorContainer.noOfpkgUnit }}</span
                            >
                          </md-layout>
                        </md-layout>
                      </md-layout>

                      <md-layout md-gutter class="labelMargtop">
                        <md-layout md-flex="20">
                          <label>Cargo Stuffing Date</label>
                          <date-picker
                            :format="selectDateFormat"
                            lang="en"
                            name="cargoStuffingDate"
                            id="cargoStuffingDate"
                            v-model="ContainerTypeSizefactory.cargoStuffingDate"
                            :minute-step="1"
                          ></date-picker>
                        </md-layout>
                        <md-layout md-flex="5"></md-layout>
                        <md-layout md-flex="20">
                          <label>LEEO (Let Export Permit) Date</label>
                          <date-picker
                            :format="selectDateFormat"
                            lang="en"
                            name="leeoDate"
                            id="leeoDate"
                            v-model="ContainerTypeSizefactory.leeoDate"
                            :minute-step="1"
                          ></date-picker>
                        </md-layout>
                        <md-layout md-flex="5"></md-layout>
                        <md-layout md-flex="50">
                          <md-layout md-flex="100">
                            <label>LEEO (Let Export Permit) No.</label>
                            <b-form-input
                              :formatter="capitalizeAll"
                              name="leeoNo"
                              id="leeoNo"
                              v-model="ContainerTypeSizefactory.leeoNo"
                            ></b-form-input>
                          </md-layout>
                        </md-layout>
                      </md-layout>
                    </div>
                  </div>
                </b-card>

                <div class="box-body mt-2">
                  <table id="ccContainer" class="table table-bordered">
                    <thead>
                      <tr>
                        <th>Sr No.</th>

                        <th>Container No.</th>

                        <th>Container Type</th>
                        <th>Custom Seal No.</th>
                        <th>Line Seal No.</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(item, index) in containerTypeDetailFactoryList"
                        :key="index"
                      >
                        <td>{{ index + 1 }}</td>
                        <td
                          @click="viewEdit(item.ccExecutionContainerId, index)"
                          class="showMoreData"
                        >
                          {{ item.containerNo }}
                        </td>
                        <td
                          @click="viewEdit(item.ccExecutionContainerId, index)"
                          class="showMoreData"
                        >
                          {{ item.containerType }}
                        </td>

                        <td>
                          {{
                            item.customSealNo != "" ? item.customSealNo : "--"
                          }}
                        </td>
                        <td>
                          {{ item.LineSealNo != "" ? item.LineSealNo : "--" }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <!-- /.box-body -->
              </div>
              <!-- <div class="mt-4" v-if="(SBDetail.supSlinePayId!='' && accounts==false) || (SBDetail.supSlinePayId!='' && role=='Admin') "> <b-form-checkbox

      id="checkbox-1"
      v-model="SBDetail.revisedMail"
      name="checkbox-1"
      value="1"
      unchecked-value="0"
    >
      
    </b-form-checkbox><span class="error">Send Revised Payment Request</span></div> -->
              <md-layout gutter class="gutr">
                <!-- <md-layout md-flex="45">
                  <md-input-container>
                    <label>B/L Draft By Shipping Line</label>
                    <md-file
:disabled="accounts == true && role!='Admin'?true:false"
                      name="invoiceUpload"
                      id="invoiceUpload"
                      v-model="SBDetail.blDraftUpload"
                      @selected="onFileChangeBlDraft('BL_DRAFT')"
                      multiple
                    ></md-file>
                  </md-input-container>
                </md-layout>
                <md-layout md-flex="5"></md-layout> -->
                <md-layout md-flex="50">
                  <md-input-container>
                    <label>Supplementary Invoice</label>
                    <md-file
                      :disabled="
                        accounts == true && role != 'Admin' ? true : false
                      "
                      name="invoiceUpload"
                      id="invoiceUpload"
                      v-model="SBDetail.slineInvoice"
                      @selected="onFileChangeBlDraft('Sline_Invoice')"
                      multiple
                    ></md-file>
                  </md-input-container>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="gutr">
                <!-- <div v-if="viewBLDraftDoc.length > 0">
                  <md-layout
                    md-flex="20"
                    v-for="(item, index) in viewBLDraftDoc"
                    :key="index"
                  >
                    <a
v-if="ccExportDetail.ccExportFclSeries"
                      :href="
                        `${docURL}/ASSIGNMENT_UPLOADS/` + ccExportDetail.ccExportFclSeries.replaceAll('/', '_') + '/' +
                        item
                      "
                      target="_blank"
                      download
                      >--View Document - {{ index + 1 }}</a
                    >
<br>
                  <a
                      :href="
                        `${docURL}/CC_Sea_Export_Sline_Payments_Uploads/` +
                        item
                      "
                      target="_blank"
                      download
                      >--View Document - {{ index + 1 }}</a
                    >
                  </md-layout>
                </div> -->

                <div v-if="viewInvDoc.length > 0">
                  <md-layout
                    md-flex="20"
                    v-for="(item, index) in viewInvDoc"
                    :key="index"
                  >
                    <a
                      v-if="ccExportDetail.ccExportFclSeries"
                      href="javascript:void(0)"
                      @click="openSignedDocument(`ASSIGNMENT_UPLOADS/${ccExportDetail.ccExportFclSeries.replaceAll('/', '_')}/${item}`)"
                      target="_blank"
                      >--View Document - {{ index + 1 }}</a
                    ><br />
                    <a
                      :href="
                        `${docURL}/CC_Sea_Export_Sline_Payments_Uploads/` + item
                      "
                      target="_blank"
                      download
                      >--View Document - {{ index + 1 }}</a
                    >
                  </md-layout>
                </div>
              </md-layout>
              <md-layout md-gutter class="gutr">
                <md-layout md-flex="35">
                  <md-layout md-flex="100">
                    <label>POR</label>
                    <b-form-input
                      :formatter="capitalizeAll"
                      disabled
                      name="POR"
                      id="POR"
                      v-model="POR"
                    ></b-form-input>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="20">
                  <md-layout md-flex="100">
                    <label>B/L No.</label>
                    <b-form-input
                      :formatter="capitalizeAll"
                      :disabled="
                        accounts == true && role != 'Admin' ? true : false
                      "
                      name="POR"
                      id="POR"
                      v-model="SBDetail.SlineBlNo"
                    ></b-form-input>
                  </md-layout>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="gutr">
                <md-layout md-flex="35">
                  <md-layout md-flex="100">
                    <label>Shipping Line </label>
                    <b-form-input
                      :formatter="capitalizeAll"
                      disabled
                      name="POR"
                      id="POR"
                      v-model="ccExportDetail.shippingLine"
                    ></b-form-input>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="20">
                  <md-layout md-flex="100">
                    <label>Shipping line Invoice Amount</label>
                    <b-form-input
                      :formatter="capitalizeAll"
                      :disabled="
                        accounts == true && role != 'Admin' ? true : false
                      "
                      name="shippingBillNo"
                      id="shippingBillNo"
                      v-model="SBDetail.invoiceAmount"
                      type="number"
                    ></b-form-input>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="15">
                  <label>Estimated SOB Date </label>
                  <date-picker
                    @input="getDueDate"
                    :disabled="
                      accounts == true && role != 'Admin' ? true : false
                    "
                    lang="en"
                    :format="selectDateFormat"
                    name="sobDate"
                    id="sobDate"
                    v-model="SBDetail.sobDate"
                    :minute-step="1"
                  ></date-picker>
                  <!-- <span class="error" v-if="!SBDetail.payDate">{{errorSBExecution.payDate}}</span> -->
                </md-layout>

                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="15">
                  <label>Payment Due Date</label>
                  <date-picker
                    disabled
                    lang="en"
                    :format="selectDateFormat"
                    name="sobDate"
                    id="sobDate"
                    v-model="SBDetail.dueDate"
                    :minute-step="1"
                  ></date-picker>
                  <!-- <span class="error" v-if="!SBDetail.payDate">{{errorSBExecution.payDate}}</span> -->
                </md-layout>
              </md-layout>

              <hr />
              <div
                v-if="
                  accounts == true ||
                  (SBDetail.paymentMode != '' && SBDetail.payRefNumber != '')
                "
              >
                <md-layout md-gutter class="mt-3">
                  <md-layout md-flex="95">
                    <h5>
                      <b-badge>Payment Details</b-badge>
                    </h5>
                  </md-layout>
                </md-layout>
                <md-layout md-gutter>
                  <md-layout md-flex="40">
                    <label for="custmClearByPridel">Payment Mode</label>

                    <model-list-select
                      :list="payList"
                      v-model="SBDetail.paymentMode"
                      option-value="payVal"
                      option-text="payText"
                      placeholder="Select Mode"
                    ></model-list-select>
                  </md-layout>
                </md-layout>
                <md-layout md-gutter class="gutr">
                  <md-layout md-flex="10">
                    <md-layout md-flex="100">
                      <label>Amount</label>
                      <b-form-input
                        :formatter="capitalizeAll"
                        name="shippingBillNo"
                        id="shippingBillNo"
                        v-model="SBDetail.totalAmount"
                      ></b-form-input>
                    </md-layout>
                    <!-- <span
                          class="error"
                          v-if="!SBDetail.totalAmount"
                        >{{errorSBExecution.totalAmount}}</span>-->
                  </md-layout>

                  <md-layout
                    md-flex="5"
                    v-if="SBDetail.paymentMode != ''"
                  ></md-layout>
                  <md-layout md-flex="25" v-if="SBDetail.paymentMode != ''">
                    <md-layout md-flex="100">
                      <label
                        >{{
                          SBDetail.paymentMode == "1" ? "UTR" : "Cheque"
                        }}
                        Number</label
                      >
                      <b-form-input
                        :formatter="capitalizeAll"
                        name="cargoGrossWeight"
                        id="cargoGrossWeight"
                        v-model="SBDetail.payRefNumber"
                      ></b-form-input>
                    </md-layout>
                    <!-- <span
                          class="error"
                          v-if="!SBDetail.cargoGrossWeight"
                        >{{errorSBExecution.cargoGrossWeight}}</span>-->
                  </md-layout>
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="15">
                    <label>Payment Date</label>
                    <date-picker
                      :format="selectDateFormat"
                      lang="en"
                      name="shippingBillDate"
                      id="shippingBillDate"
                      v-model="SBDetail.payDate"
                      :minute-step="1"
                    ></date-picker>
                    <!-- <span class="error" v-if="!SBDetail.payDate">{{errorSBExecution.payDate}}</span> -->
                  </md-layout>
                </md-layout>
              </div>
              <md-layout md-gutter class="gutr">
                <md-layout md-flex="25">
                  <b-button
                    class="mt-3"
                    :disabled="
                      SBDetail.paymentDone == '1' ||
                      disableSave == true ||
                      disableSaveSup == true
                        ? true
                        : false
                    "
                    variant="primary"
                    id="addButtonLoaderSB"
                    @click="addSBDetail"
                    >Save & Submit
                  </b-button>
                  <md-spinner
                    md-indeterminate
                    id="loaderSB"
                    style="display: none"
                  ></md-spinner>
                </md-layout>
              </md-layout>
            </div>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>

    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      ref="popMailAfter"
    ></md-dialog-confirm>

    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-confirm>
  </div>
</template>
<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { ModelListSelect } from "vue-search-select";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import {
  globalPermissionStatus,
  GlobalGetLocation,
  GlobalContainerValid,
} from "../../helper/collection";

export default {
  beforeMount() {
    // if (
    //   (globalPermissionStatus("Sea Freight") ||
    //     globalPermissionStatus("Accounts")) &&
    //   this.$sessionsStorage.get("editffSeaImportId") != undefined &&
    //   this.$sessionsStorage.get("editffSeaImportId") != ""
    // )

    if (
      globalPermissionStatus("Sea Freight") ||
      globalPermissionStatus("Accounts")
    ) {
      this.$store.dispatch(
        "setCurrentRoute",
        "/seaImport/ffSLinePaymentImportN"
      );
      // if(suplimentaryInvDataSingleArry && suplimentaryInvDataSingleArry.length>0){
      //this.supccSlinePayDataArry=suplimentaryInvDataSingleArry;
      // //alert()

      // }
      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },
  watch: {
    ContainerTypeSizefactory: {
      handler(newVal, oldVal) {
        if (newVal.hasOwnProperty("containerNo")) {
          this.ContainerTypeSizefactory.containerNo =
            newVal.containerNo.toUpperCase();

          if (this.ContainerTypeSizefactory.packageId != "") {
            let arrayNew = this.packageNameList.filter((x) => {
              return x.packageId == this.ContainerTypeSizefactory.packageId;
            });

            if (arrayNew.length > 0) {
              this.ContainerTypeSizefactory.packageName =
                arrayNew[0].packageName;
            }
          }
        }
      },
      deep: true,
    },
    //  SBDetail: {
    //       handler(newVal, oldVal) {
    //        if(this.SBDetail.sobDate){
    // var date = new Date(this.SBDetail.sobDate);
    // console.log(date)
    // if(this.ccExportDetail.shippingId=='15'){
    //  this.SBDetail.dueDate=date.setDate(date.getDate() + 9);
    //  this.SBDetail.dueDate=new Date(this.SBDetail.dueDate)
    // }else if(this.ccExportDetail.shippingId=='8'){

    //  this.SBDetail.dueDate=date.setDate(date.getDate() + 9);
    // this.SBDetail.dueDate=new Date(this.SBDetail.dueDate)
    // }else if(this.ccExportDetail.shippingId=='13'){

    //   this.SBDetail.dueDate=date.setDate(date.getDate() + 9);
    // this.SBDetail.dueDate=new Date(this.SBDetail.dueDate)
    // }else if(this.ccExportDetail.shippingId=='27'){
    //  this.SBDetail.dueDate=date.setDate(date.getDate() + 13);
    // this.SBDetail.dueDate=new Date(this.SBDetail.dueDate)

    // }else{
    //  this.SBDetail.dueDate=date.setDate(date.getDate() + 6) ;
    // this.SBDetail.dueDate=new Date(this.SBDetail.dueDate)
    // }

    // }
    //       },
    //       deep: true,
    //     },
  },
  props: ["suplimentaryInvDataSingleArry"],
  data() {
    return {
      syncFlag: false,
      invnoErrFlag: false,
      selectDateFormat,
      accounts: globalPermissionStatus("Accounts"),
      payList: [
        {
          payVal: "1",
          payText: "RTGS",
        },
        {
          payVal: "2",
          payText: "Cheque",
        },
      ],
      showAlgo: false,
      algoConNo: "",
      docURL: URL_BASE_DOC,
      isLoading: false,
      value12: "",
      CCdone: "",
      alert: {
        content: "Added Succesfully",
        ok: "ok",
      },
      unitList: [
        {
          uT: "KGS",
          uV: "KGS",
        },
        {
          uT: "MT",
          uV: "MT",
        },
      ],

      CCList: [
        {
          ccInfoVal: "Yes",
          ccInfoText: "Yes",
        },
        {
          ccInfoVal: "No",
          ccInfoText: "No",
        },
      ],
      getContainerList: [],
      getLocationList: [],
      ccExportDetail: {
        POR: "",
        allModuleId: "",
        clientName: "",
        ccExportFclSeries: "",
        portType: "",
        stuffingType: "",
        containerInfo: "",
        mergeExportId: "",
        mergeSeries: "",
        shippingLine: "",
        FinalPlace: "",
        POR: "",
      },
      POR: "",
      SBDetail: {
        revisedMail: "0",
        dueDate: "",
        SlineBlNo: "",
        invoiceAmount: "",
        sobDate: "",
        allModuleId: "",
        paymentDone: "",
        userId: "",
        stuffingType: "",
        blDraftUpload: "",
        slineInvoice: "",
        suplimentaryInvCount: "",
        supSlinePayId: "",
        ExportId: "",
        ccBookingId: "",
        ExecutionId: "",
        doc2: "",
        paymentMode: "",
        totalAmount: "",
        payRefNumber: "",
        payDate: "",
        salesExeuctionNo: "",
        sline: "",
        clientName: "",
      },

      errorSBExecution: {
        shippingBillDate: "",
        shippingBillNo: "",

        cargoGrossWeight: "",
      },
      arraySBExecutionError: [
        "Enter Shippping Bill Date",
        "Enter Shipping Bill No",
        "Enter Cargo Weight",
      ],
      errorAtleastSb: "",
      errorAtleastContainer: "",

      WarehouseStuffing: {
        vgmSubmissionDate: "",
        gateInDate: "",
        siSubmissionDate: "",
        ExecutionId: "",
        ccImportId: this.$sessionsStorage.get("editffSeaImportId"),

        stuffingType: "",
        portType: "",

        nameOfCFS: "",
        cartingDate: "",
        crnNumber: "",

        custmClearByPridel: "",
        ccAsignmentNo: "",
        containerInfo: "",
      },
      permissionStatus: true,
      sbDetailArray: [],
      supffSlinePayDataArry: [],
      showMoreSB: false,

      errorExecution: {
        cartingDate: "",
        crnNumber: "",
      },
      nameOfCFSError: "",
      arrayExecutionError: ["Select Carting Date", "Enter CRN Number"],

      ContainerTypeSizefactory: {
        netWeight: "",
        weightUnit: "",
        ccExecutionContainerId: "",
        containerTypeId: "",
        containerType: "",
        containerNo: "",
        cargoWeight: "",
        tareWeight: "",
        grossWeight: "",
        customSealNo: "",
        LineSealNo: "",
        cargoStuffingDate: "",
        leeoDate: "",
        leeoNo: "",
        handoverDate: "",
        measurement: "",
        packageId: "",
        packageName: "",
        noOfpkgUnit: "",
      },

      removeContainerVmodel: {
        ccExecutionContainerId: "",
        containerTypeId: "",
        containerType: "",
        containerNo: "",
        cargoWeight: "",
        tareWeight: "",
        grossWeight: "",
        customSealNo: "",
        LineSealNo: "",
        measurement: "",
        packageId: "",
        packageName: "",
        noOfpkgUnit: "",
      },
      role: this.$sessionsStorage.get("designation"),
      packageNameList: [],
      nextPageType: "",

      errorContainer: {
        containerTypeId: "",
        containerNo: "",
        grossWeight: "",
        //    measurement: "",
        packageId: "",
        noOfpkgUnit: "",
      },
      arrayContainerError: [
        "Select Container Type",
        "Enter Container No.",
        "Enter Container Gross Weight1",
        // "Enter measurement",
        "Select Package",
        "Enter No of Packages",
      ],
      ContainerFromTPT: [],
      ContainerNoTPT: [],
      ContainerNoTypeTPT: [],
      editIndex: "",
      deleteId: "",
      showDivCountNote: false,
      BookingShippingLine: {
        assignmentNumber: "",
        bookingNumber: "",
        uploadBooking: "",
        validityBookingDate: "",
        bookingDate: "",
        vesselName: "",
        SICutOff: "",
        gateOpenDate: "",
        gateOpenTime: "",
        gateCloseDate: "",
        gateCloseTime: "",
        portCutDate: "",
        portCutTime: "",
        ENSCutDate: "",
        ENSCutTime: "",
        bookingShipment: "",
        stuffingType: "",
        vesselEta: "",
        vesselEtd: "",
        vgmCutOffDate: "",
        documentCutOffDate: "",
        voyageNo: "",
      },
      validateTrans: true,
      disableSaveSup: false,
      validateSB: true,
      containerTypeDetailFactory: [],
      containerNoRegexError: "",
    };
  },

  mounted() {},

  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect,
    // Loading,
    CustomLoader,
  },
  computed: {
    disableSave() {
      return this.accounts == false &&
        this.role != "Admin" &&
        (!this.SBDetail.SlineBlNo ||
          !this.SBDetail.invoiceAmount ||
          !this.SBDetail.sobDate ||
          !this.SBDetail.slineInvoice)
        ? true
        : false;
    },
    viewBLDraftDoc() {
      return this.SBDetail.blDraftUpload != ""
        ? this.SBDetail.blDraftUpload.split(",")
        : [];
    },
    viewInvDoc() {
      return this.SBDetail.slineInvoice != ""
        ? this.SBDetail.slineInvoice.split(",")
        : [];
    },

    viewSlineInvDoc() {
      return this.SBDetail.slineInvoice != ""
        ? this.SBDetail.slineInvoice.split(",")
        : [];
    },
    sbDetailArrayList() {
      return this.sbDetailArray;
    },
    containerTypeDetailFactoryList() {
      return this.containerTypeDetailFactory;
    },
    ContainerTypeList() {
      return this.getContainerList;
    },
    masterList() {
      return this.getLocationList;
    },
  },
  methods: {
    getDueDate() {
      var date = new Date(this.SBDetail.sobDate);
      console.log(date);
      if (this.ccExportDetail.shippingId == "15") {
        this.SBDetail.dueDate = date.setDate(date.getDate() + 9);
        this.SBDetail.dueDate = new Date(this.SBDetail.dueDate);
      } else if (this.ccExportDetail.shippingId == "8") {
        this.SBDetail.dueDate = date.setDate(date.getDate() + 9);
        this.SBDetail.dueDate = new Date(this.SBDetail.dueDate);
      } else if (this.ccExportDetail.shippingId == "13") {
        this.SBDetail.dueDate = date.setDate(date.getDate() + 9);
        this.SBDetail.dueDate = new Date(this.SBDetail.dueDate);
      } else if (this.ccExportDetail.shippingId == "27") {
        this.SBDetail.dueDate = date.setDate(date.getDate() + 13);
        this.SBDetail.dueDate = new Date(this.SBDetail.dueDate);
      } else {
        this.SBDetail.dueDate = date.setDate(date.getDate() + 6);
        this.SBDetail.dueDate = new Date(this.SBDetail.dueDate);
      }
    },
    onFileChangeBlDraft(ID) {
      this.isLoading = true;
      let files = event.target.files || event.dataTransfer.files;
      let ccImportId = this.$sessionsStorage.get("editffSeaImportId");
      let formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append("file[]", files[i]);

        if (ID == "Sline_Invoice") {
          formData.append(
            "staticFileName",
            "suplimentrySlineInvoive_" + ccImportId
          );
        } else if (ID == "BL_DRAFT") {
          formData.append(
            "staticFileName",
            "suplimentrySlineBLDraft_" + ccImportId
          );
        }

        formData.append(
          "upload_dir_folderName",
          // "CC_Sea_Export_Sline_Payments_Uploads"
          this.ccExportDetail.ccImportSeries.replaceAll("/", "_")
        );
      }

      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Accept: ID + ccImportId,
        },
      };

      axios
        .post(`${URL_BASE}/uploadFileCommonForAllTest.php`, formData, config)
        .then((result) => {
          if (ID == "BL_DRAFT") {
            this.SBDetail.blDraftUpload = result.data;
          } else {
            this.SBDetail.slineInvoice = result.data;
          }
          this.isLoading = false;
        })
        .catch((err) => {
          throw err;
        });
    },

    getConAlgoList() {
      //let self = this;

      if (this.ContainerTypeSizefactory.containerNo != "") {
        this.validContainerNo = GlobalContainerValid(
          this.ContainerTypeSizefactory.containerNo
        );
      }
    },

    doLoading() {
      this.isLoading = true;
    },
    doLoadingClose() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    previousSalesView() {
      window.history.go(-1);
      // if (this.ccExportDetail.containerInfo == "lcl") {
      //   this.$router.push({
      //     path: "/freightForward/ccExportFcl"
      //   });
      // } else {
      //   this.$router.push({
      //     path: "/freightForward/ccBooking"
      //   });
      // }
    },

    validateSBDetail() {
      let validate_new = true;
      Object.keys(this.errorSBExecution).map((x, index) => {
        if (this.SBDetail[x] == "") {
          this.errorSBExecution[x] = this.arraySBExecutionError[index];
          validate_new = false;
        }
      });

      if (validate_new == false) {
        this.validateSB = false;
      } else {
        this.validateSB = true;
      }
    },
    showMoreSBDet() {
      if (this.showMoreSB == false) {
        this.ContainerTypeSizefactory.ccExecutionContainerId == "";
        this.showMoreSB = true;
      } else {
        this.showMoreSB = false;
      }
    },
    viewEdit(id, index) {
      let array = this.containerTypeDetailFactory.filter((x) => {
        return x.ccExecutionContainerId == id;
      });

      Object.keys(this.ContainerTypeSizefactory).map((x) => {
        this.ContainerTypeSizefactory[x] = array[0][x];
      });
      this.showMoreSB = false;
    },

    addSBDetail() {
      this.isLoading = true;
      this.disableSaveSup = true;

      this.SBDetail["ccImportSeries"] =
        this.ccExportDetail.ccImportSeries.replaceAll("/", "_");

      if (!this.SBDetail.slineInvoice && this.SBDetail.supSlinePayId == "") {
        this.alert.content = "Please Upload  Supplementary Invoice ";
        this.$refs["addPop"].open();
        return false;
      }
      this.SBDetail["uploadArray"] = [];
      if (this.SBDetail.slineInvoice) {
        let obj = {
          allModuleId: this.ccExportDetail.allModuleId,
          docName:
            "suplimentrySlineInvoive_-" +
            this.$sessionsStorage.get("editffSeaImportId"),
          docLink: this.SBDetail.slineInvoice,
          doc2: this.SBDetail.doc2,
        };
        this.SBDetail.uploadArray.push(obj);
      }
      if (this.SBDetail.blDraftUpload) {
        let obj1 = {
          allModuleId: this.ccExportDetail.allModuleId,
          docName:
            "suplimentrySlineBLDraft_-" +
            this.$sessionsStorage.get("editffSeaImportId"),
          docLink: this.SBDetail.blDraftUpload,
          doc2: this.SBDetail.doc2,
        };
        this.SBDetail.uploadArray.push(obj1);
      }

      this.SBDetail["stuffingType"] = this.WarehouseStuffing.stuffingType;
      this.SBDetail["ExportId"] = this.$sessionsStorage.get("editffSeaImportId");
      this.SBDetail["ffBookingId"] =
        this.$sessionsStorage.get("editFFBookingId");
      // this.SBDetail["ExecutionId"] ='0' ;
      this.SBDetail["ExecutionId"] =
        this.$sessionsStorage.get("editFFExecutionId"); // Added Extra Priyanshu Singh
      this.SBDetail.clientName = this.ccExportDetail.clientName;
      this.SBDetail.sline = this.ccExportDetail.shippingLine;
      this.SBDetail.POR = this.ccExportDetail.POR;
      this.SBDetail.salesExeuctionNo = this.ccExportDetail.ccImportSeries;
      console.log(this.SBDetail);
      //return false
      // this.validateSBDetail();
      if (this.validateSB != false) {
        // $("#addButtonLoaderSB").css("display", "none");
        // $("#loaderSB").css("display", "block");

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_SlineBillingCCExport/importSuplimentCCExportSlinePayAdd.php`,
          data: JSON.stringify(this.SBDetail),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              window.history.go(-1);
              // $("#loaderSB").css("display", "none");
              // $("#addButtonLoaderSB").css("display", "block");
              // window.history.go(-1);

              // if (data.msg == "Inserted Successfully") {
              //   this.alert.content = "Data Added Successfully";
              // } else {
              //   this.alert.content = "Data Updated Successfully";
              //   this.$refs["addPop"].open();
              // }
            }
            this.isLoading = false;
          })
          .catch((error) => {});
      }
    },

    containerNoRegexfun() {
      this.showAlgo = true;
      this.getConAlgoList();
      this.algoConNo = this.validContainerNo;
      // let lastDigitReturn = this.validContainerNo.slice(
      //   this.validContainerNo.length - 7
      // );
      // let lastDigitCon = this.ContainerTypeSizefactory.containerNo.slice(
      //   this.ContainerTypeSizefactory.containerNo.length - 7
      // );
      let containerformat = new RegExp("^[a-zA-Z]{4}[0-9]{7}$");
      let arrayLen = [];
      if (this.ContainerTypeSizefactory.ccExecutionContainerId == "") {
        arrayLen = this.containerTypeDetailFactoryList.filter((x) => {
          return x.containerNo == this.ContainerTypeSizefactory.containerNo;
        });
      }

      if (
        arrayLen.length > 0 &&
        this.ContainerTypeSizefactory.ccExecutionContainerId == ""
      ) {
        this.containerNoRegexError = "Already Exist";
      } else if (
        containerformat.test(this.ContainerTypeSizefactory.containerNo)
      ) {
        this.containerNoRegexError = "";
      } else {
        this.containerNoRegexError = "Enter Valid Format";
      }
    },

    getData() {
      this.doLoading();
      this.disableSaveSup = false;
      if (this.sbDetailArrayList.length == 1) {
        this.sbDetailArray = [];
      }
      if (this.containerTypeDetailFactory.length == 1) {
        this.containerTypeDetailFactory = [];
      }
      if (this.getContainerList.length == 1) {
        this.getContainerList = [];
      }
      let new_data = {
        ccExportId: this.$sessionsStorage.get("editffSeaImportId"),
        allModuleId: this.$sessionsStorage.get("allModuleId"),
        TYPE: this.$sessionsStorage.get("TYPE"),
        JOBSERIES: this.$sessionsStorage.get("JOBSERIES"),
        EXPORTER: this.$sessionsStorage.get("EXPORTER"),
      };
      console.log("new_data=>", new_data);
      console.log("editFFExecutionId=>", this.$sessionsStorage.get("editFFExecutionId"));
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_SlineBillingCCExport/viewccimpslinePaymentDetails.php`,
        data: JSON.stringify(new_data),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;

          if (status == 200 && data) {
            console.log("MyDataArr=>", data);

            if (data.ContainerFromTPT.length > 0) {
              if (!this.$sessionsStorage.get("editFFExecutionId")) {
                this.$sessionsStorage.set(
                  "editFFExecutionId",
                  data.autoExecutionId
                );
              }
              this.ContainerFromTPT = data.ContainerFromTPT;

              if (data.ContainerFromTPT[0].ContainerNumber != null) {
                this.ContainerNoTPT =
                  data.ContainerFromTPT[0].ContainerNumber.split(",");
              }
              if (data.ContainerFromTPT[0].ContainerType.length > 0) {
                this.ContainerNoTypeTPT =
                  data.ContainerFromTPT[0].ContainerType.split(",");
              }
              this.conDetailsTPT =
                data.ContainerFromTPT[0].ContainerType +
                "\n" +
                data.ContainerFromTPT[0].ContainerNumber;
            }

            this.getLocationList = data.portLocationArray;
            // if (data.containerCountWise.length > 0) {
            //   this.containerCountWise = data.containerCountWise;
            //   let array_new = this.containerCountWise.map((x) => {
            //     if (x.totalCount == 0) {
            //       this.showDivCountNote = false;
            //     } else {
            //       this.showDivCountNote = true;
            //       return false;
            //     }
            //   });
            // }
             console.log("Priyanshu Singh=>", data);
            console.log("data.packageNameList",data.packageNameList);
            if (data.packageNameList.length > 0) {
              this.packageNameList = data.packageNameList;
            }

            if (data.containerMaster.length > 0) {
              this.getContainerList = data.containerMaster;
            }

            // if (data.ffBookingDetail.length > 0) {
            //   Object.keys(data.ffBookingDetail[0]).map((x) => {
            //     this.BookingShippingLine[x] = data.ffBookingDetail[0][x] || "";
            //   });
            // }

            if (data.editCCEX.length > 0) 
            {
                this.WarehouseStuffing.portType = data.editCCEX[0].portType;
                this.SBDetail.allModuleId = data.editCCEX[0].allModuleId;
                this.POR = data.editCCEX[0].POR;
                this.WarehouseStuffing.stuffingType =data.editCCEX[0].stuffingType;
                this.WarehouseStuffing.containerInfo =data.editCCEX[0].containerInfo;
                Object.keys(data.editCCEX[0]).map((x) => {
                    this.ccExportDetail[x] = data.editCCEX[0][x] || "";
                });
            }
            if (data.ffBookingTranshipment.length > 0) {
              this.tentativeDetailArray = data.ffBookingTranshipment;
            }

            if (
              this.$sessionsStorage.get("editFFExecutionId") != "" &&
              this.$sessionsStorage.get("editFFExecutionId") != undefined
            ) {
              this.viewExecutionDetail();
            } else {
              this.doLoadingClose();
            }
            // this.JqueryFun();
          }
        })
        .catch((error) => {});
    },
    viewExecutionDetail() {
      console.log(this.suplimentaryInvDataSingleArry, "uiyiu");
      console.log(this.ccExportDetail, "ccExportDetail");
      this.doLoading();
      let new_data = {
        ccExportId: this.$sessionsStorage.get("editffSeaImportId"),
        ccExecutionId: this.$sessionsStorage.get("editFFExecutionId"),
        newData: this.ccExportDetail,
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_SlineBillingCCExport/viewCCimportExecutionDetailsMulti.php`,
        data: JSON.stringify(new_data),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;

          if (status == 200 && data) {
            console.log(this.suplimentaryInvDataSingleArry, "tuytyrr");
            if (this.suplimentaryInvDataSingleArry.length > 0) {
              Object.keys(this.SBDetail).map((x) => {
                this.SBDetail[x] =
                  this.suplimentaryInvDataSingleArry[0][x] || "";
              });
            } else {
              Object.keys(this.SBDetail).map((x) => {
                this.SBDetail[x] = "";
              });
              if (data.ccSLinePayDetail.length > 0) {
                Object.keys(this.SBDetail).map((x) => {
                  this.SBDetail[x] = data.ccSLinePayDetail[0][x] || "";
                });

                this.SBDetail.slineInvoice = "";
                this.SBDetail.blDraftUpload = "";
                this.SBDetail.invoiceAmount = "";
                this.SBDetail.paymentMode = "";
                this.SBDetail.paymentDone = "";
                this.SBDetail.payRefNumber = "";
                this.SBDetail.payDate = "";
                this.SBDetail.totalAmount = "";
              }
            }

            console.log(this.SBDetail, "yioiu");
            if (data.ccExecutionDetail.length > 0) {
              Object.keys(this.WarehouseStuffing).map((x) => {
                this.WarehouseStuffing[x] = data.ccExecutionDetail[0][x] || "";
              });
            }

            if (data.ccExecutionDetailContainer.length > 0) {
              if (this.ContainerFromTPT.length > 0) {
                let dummyContainer = [];
                for (
                  let i = 0;
                  i < data.ccExecutionDetailContainer.length;
                  i++
                ) {
                  let obj = {
                    ccExecutionContainerId:
                      data.ccExecutionDetailContainer[i].ccExecutionContainerId,
                    containerTypeId:
                      data.ccExecutionDetailContainer[i].containerTypeId,
                    containerType:
                      data.ccExecutionDetailContainer[i].containerType,
                    LineSealNo: data.ccExecutionDetailContainer[i].LineSealNo,
                    PickupLocation:
                      data.ccExecutionDetailContainer[i].PickupLocation,
                    StuffingLocation:
                      data.ccExecutionDetailContainer[i].StuffingLocation,
                    cargoStuffingDate:
                      data.ccExecutionDetailContainer[i].cargoStuffingDate,
                    cargoWeight: data.ccExecutionDetailContainer[i].cargoWeight,
                    containerInfo:
                      data.ccExecutionDetailContainer[i].containerInfo,
                    containerWithSplit:
                      data.ccExecutionDetailContainer[i].containerWithSplit,
                    customSealNo:
                      data.ccExecutionDetailContainer[i].customSealNo,
                    ccExecutionId:
                      data.ccExecutionDetailContainer[i].ccExecutionId,
                    ccImportId: data.ccExecutionDetailContainer[i].ccExportId,
                    grossWeight: data.ccExecutionDetailContainer[i].grossWeight,
                    handoverDate:
                      data.ccExecutionDetailContainer[i].handoverDate,
                    leeoDate: data.ccExecutionDetailContainer[i].leeoDate,
                    leeoNo: data.ccExecutionDetailContainer[i].leeoNo,
                    measurement: data.ccExecutionDetailContainer[i].measurement,
                    netWeight: data.ccExecutionDetailContainer[i].netWeight,
                    noOfpkgUnit: data.ccExecutionDetailContainer[i].noOfpkgUnit,
                    packageId: data.ccExecutionDetailContainer[i].packageId,
                    pickupDate: data.ccExecutionDetailContainer[i].pickupDate,
                    portType: data.ccExecutionDetailContainer[i].portType,
                    stuffingDate:
                      data.ccExecutionDetailContainer[i].stuffingDate,
                    tareWeight: data.ccExecutionDetailContainer[i].tareWeight,
                    weightUnit: data.ccExecutionDetailContainer[i].weightUnit,
                    containerNo:
                      data.ccExecutionDetailContainer[i].containerNo == ""
                        ? this.ContainerNoTPT[i]
                        : data.ccExecutionDetailContainer[i].containerNo,
                  };
                  dummyContainer.push(obj);
                }
                this.containerTypeDetailFactory = dummyContainer;
              } else {
                this.containerTypeDetailFactory =
                  data.ccExecutionDetailContainer;
              }

              Object.keys(this.ContainerTypeSizefactory).map((x) => {
                this.ContainerTypeSizefactory[x] =
                  data.ccExecutionDetailContainer[0][x] || "";
              });

              Object.keys(this.removeContainerVmodel).map((x) => {
                this.ContainerTypeSizefactory[x] = "";
              });
            }

            if (data.ccSBDetail.length > 0) {
              this.sbDetailArray = data.ccSBDetail;
            }
            this.doLoadingClose();
          }
        })
        .catch((error) => {});
    },
    // JqueryFun() {
    //   return $(function() {
    //     return $("#ccContainer").DataTable();
    //   });
    // }
  },
};
</script>
<style>
.md-direction-bottom-right {
  width: 18% !important;
}

.center {
  text-align: center;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>



// WEBPACK FOOTER //
// ffSuplementrySlinePaymentImp.vue?6d6c7a15